// http://pmapi.dholdingsltd.com
export const apiUrl = process.env.REACT_APP_API_BASE_URL;
export const isAdminLoggedIn = window.localStorage.getItem("admin");
export const isEmployeeLoggedIn = window.localStorage.getItem("employeeToken");
